import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { Wrapper, Logo, Name } from './styles';

const BankLabel = memo(({ logo, name, ...props }) => (
  <Wrapper {...props}>
    {logo && <Logo src={logo} alt={name} />}
    <Name>{name}</Name>
  </Wrapper>
));

BankLabel.propTypes = {
  name: PropTypes.string,
  logo: PropTypes.string,
};

BankLabel.defaultProps = {
  name: '',
  logo: '',
};

export default BankLabel;
